import { render, staticRenderFns } from "./UploadFileNewOne.vue?vue&type=template&id=7980877f&scoped=true"
import script from "./UploadFileNewOne.vue?vue&type=script&lang=js"
export * from "./UploadFileNewOne.vue?vue&type=script&lang=js"
import style0 from "./UploadFileNewOne.vue?vue&type=style&index=0&id=7980877f&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980877f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7980877f')) {
      api.createRecord('7980877f', component.options)
    } else {
      api.reload('7980877f', component.options)
    }
    module.hot.accept("./UploadFileNewOne.vue?vue&type=template&id=7980877f&scoped=true", function () {
      api.rerender('7980877f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/subgroup/UploadFileNewOne.vue"
export default component.exports